const Papa = require("papaparse");
const ExcelJS = require("exceljs");

function parseDelimitedText(text) {
  const result = Papa.parse(text, {
    header: true,
    skipEmptyLines: "greedy",
    transform: (value) => (value == null ? "" : value),
  });

  const fields = result.meta.fields;
  if (!fields || fields.length === 0) {
    return { headers: [], rows: [] };
  }

  const headers = fields.map((field) => String(field ?? "").trim());
  const rows = result.data.map((row) => fields.map((field) => String(row[field] ?? "")));

  return { headers, rows };
}

async function parseXlsxWorkbook(buffer) {
  const workbook = new ExcelJS.Workbook();
  await workbook.xlsx.load(buffer);
  const sheets = [];

  workbook.eachSheet((worksheet) => {
    const matrix = [];
    let maxCols = 0;
    worksheet.eachRow((row) => {
      const cells = [];
      row.eachCell({ includeEmpty: true }, (cell) => {
        cells.push(cell.text ?? "");
      });
      matrix.push(cells);
      maxCols = Math.max(maxCols, cells.length);
    });

    if (matrix.length === 0) {
      sheets.push({ name: worksheet.name, headers: [], rows: [] });
      return;
    }

    const padRow = (r) => {
      const result = r.map((c) => String(c ?? ""));
      while (result.length < maxCols) result.push("");
      return result;
    };
    const headers = padRow(matrix[0]).map((h) => h.trim());
    const rows = matrix.slice(1).map(padRow);
    sheets.push({ name: worksheet.name, headers, rows });
  });

  return sheets;
}

const SpreadsheetPreviewPort = {
  add: function (app) {
    if (!app.ports.requestSpreadsheetPreview || !app.ports.spreadsheetPreviewResult) {
      return;
    }

    app.ports.requestSpreadsheetPreview.subscribe(async ({ requestId, url, kind }) => {
      const sendFail = () => {
        app.ports.spreadsheetPreviewResult.send({ requestId, ok: false, kind });
      };

      try {
        const res = await fetch(url);
        if (!res.ok) {
          sendFail();
          return;
        }

        if (kind === "csv") {
          const text = await res.text();
          const grid = parseDelimitedText(text);
          app.ports.spreadsheetPreviewResult.send({ requestId, ok: true, kind: "csv", grid });
        } else if (kind === "xlsx") {
          const buffer = await res.arrayBuffer();
          const sheets = await parseXlsxWorkbook(buffer);
          app.ports.spreadsheetPreviewResult.send({ requestId, ok: true, kind: "xlsx", sheets });
        } else {
          sendFail();
        }
      } catch {
        sendFail();
      }
    });
  },
};

module.exports = SpreadsheetPreviewPort;
